import React, {FC, useEffect, useState} from "react";
import {Checkbox, Drawer} from "antd";
import Button from "mixins/ui/button/button";
import {CheckboxChangeEvent} from "antd/lib/checkbox/Checkbox";
import {AdminDesignManagement} from "/react4xp/parts/admin-design-management/admin-design-management.type";

const AddBlocks: FC<AdminDesignManagement.AddBlockProps> = (props: AdminDesignManagement.AddBlockProps) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [items, setItems] = useState<any[]>([]);

    const getItems = (arr: any[]): any[] => {
        const items = [];

        arr.forEach(x => {
            if (props.configData['ru'][`${x.id}IsHidden`]) {
                items.push({
                    id: x.id,
                    name: props.configData['ru'][`${x.id}AdminName`]
                });
            }
        });

        return items;
    };

    useEffect(() => {
        if (props.arr) {
            setItems(getItems(props.arr));
        }
    }, [props.arr]);

    const onChange = (e: CheckboxChangeEvent) => {
        if (e.target.checked) {
            setSelectedItems([...selectedItems, e.target.value]);
        } else {
            setSelectedItems([...selectedItems.filter(x => x !== e.target.value)]);
        }
    };

    const onSave = () => {
        props.onSave(selectedItems);
        setSelectedItems([]);
        props.onClose();
    };

    return (
        <Drawer title="Добавить ряд блоков" placement="right" onClose={props.onClose} open={props.open} width={500}>
            {items.length > 0 ? (
                items.map(x => (
                    <div key={x.id}>
                        <Checkbox onChange={onChange} value={x.id}>{x.name}</Checkbox>
                    </div>
                ))
            ) : (
                <div>Отсутствуют блоки, доступные для восстановления</div>
            )}

            <hr />

            <div className="d-flex gap-3">
                <Button onClick={props.onClose}>Отмена</Button>
                <Button color="gold" onClick={onSave}>Сохранить</Button>
            </div>
        </Drawer>
    );
};

export default AddBlocks;
